import React, { useState, useEffect } from 'react'
import {
  makeStyles,
  createStyles,
  Box,
  Button,
  Typography,
  Menu,
  MenuItem,
  Divider,
  Card,
  useTheme,
  InputAdornment,
  IconButton,
  Dialog,
  // DialogTitle,
  DialogContent,
} from '@material-ui/core'
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom'
import useMediaQuery from '@material-ui/core/useMediaQuery'
// import { ReactComponent as Report } from 'src/mobile/assets/icons/profile/report.svg'
import { ReactComponent as Appointment } from 'src/mobile/assets/icons/order_my.svg'
import { ReactComponent as Exclamation } from 'src/mobile/assets/icons/profile_icon.svg'

// import { ReactComponent as Gifts } from 'src/mobile/assets/icons/profile/gifts.svg'
// import { ReactComponent as Advice } from 'src/mobile/assets/icons/profile/advice.svg'
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined'
import { ReactComponent as whatsApp } from 'src/mobile/assets/icons/profile/whatsapp.svg'
import { ReactComponent as WeChat } from 'src/mobile/assets/icons/profile/wechat.svg'
import useUserSession from 'src/hooks/useUserSession'
import { ESwitch } from 'src/mobile/themes/components/ESwitch'
import EDialog from 'src/mobile/themes/components/EDialog'
import EDrawer from 'src/mobile/themes/components/EDrawer'
import UserInfoForm from 'src/mobile/components/UserInfoForm2'
import { useDispatch } from 'react-redux'
import { signOut, updateUserInfo } from 'src/store/slices/authSlice'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import AddIcon from '@material-ui/icons/Add'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import CloseIcon from '@material-ui/icons/Close'
import useAuthRedirect from 'src/hooks/useAuthRedirect'
import ChangePasswordForm from 'src/mobile/components/ChangePasswordForm'
import ChangePhoneForm from 'src/mobile/components/ChangePhoneForm'
import ChangeSocialAccountForm from 'src/mobile/components/ChangeSocialAccountForm'
import OrderList from './order/OrderList'
import { encryptId } from 'src/utils'
import VisibilityOutlined from '@material-ui/icons/VisibilityOutlined'
import VisibilityOffOutlined from '@material-ui/icons/VisibilityOffOutlined'
import { buttonClick } from 'src/utils/trackingCode'
const MENU_LIST = [
  {
    label: 'glossary.personal_info',
    icon: PersonOutlineOutlinedIcon,
    path: 'profile/account',
    buttonName: 'EH_MyAccount_PersonalDetails_Tab'
  },
  {
    label: 'profile.my_appointment',
    icon: Appointment,
    path: 'profile/order',
    buttonName: 'EH_MyAccount_MyBooking_Tab'
  },
  // {
  //   label: 'profile.my_report',
  //   icon: Report,
  // },
  // {
  //   label: 'profile.redeem_gifts',
  //   icon: Gifts,
  // },
  // {
  //   label: 'profile.give_advice',
  //   icon: Advice,
  // },
]

const ACCOUNTS = [
  {
    key: 'phone',
    label: 'profile.tel_number',
  },
  {
    key: 'email',
    label: 'form.address_email',
  },
]

const PROFILE_LIST = [
  { key: 'nameEn', label: 'form.en_name' },
  { key: 'nameCn', label: 'form.zh_name' },
  { key: 'identifyId', label: 'common.id_mumber' },
  { key: 'gender', label: 'form.gender' },
  { key: 'birthday', label: 'form.birthday' },
]

const SOCIAL_ACCOUNT = [
  {
    key: 'whatsAppId',
    label: 'WhatsApp',
    icon: whatsApp,
  },
  {
    key: 'weChatId',
    label: 'WeChat',
    icon: WeChat,
  },
]

const useStyles = makeStyles((theme) =>
  createStyles({
    header: {
      position: 'sticky',
      top: 0,
      background: '#fff',
      zIndex: 99,
    },
    logo: {
      display: 'block',
      width: theme.spacing(11),
    },
    title: {
      fontWeight: 600,
      fontSize: theme.spacing(2),
    },
    menuItem: {
      paddingRight: theme.spacing(8),
    },
    menuItemIcon: {
      marginRight: theme.spacing(1),
    },
    menuButton: {
      borderRadius: theme.spacing(3),
      background: '#F9FAFB',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    menuButtonIcon: {
      color: theme.palette.secondary.main,
      '& path': {
        fill: theme.palette.secondary.main,
      },
      marginRight: theme.spacing(1),
      width: 20,
      height: 20,
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
    },
    accountButton: {
      borderRadius: theme.spacing(3),
      fontSize: theme.typography.body1.fontSize,
      borderColor: '#D1D5DB',
      marginTop: theme.spacing(2),
      width: theme.spacing(23),
      height: theme.spacing(5.5),
      fontWeight: '600',
      [theme.breakpoints.down('xs')]: {
        width: '100%',
        borderColor: '#EBEBEC',
        marginTop: theme.spacing(1),
      },
    },
    editAccountButton: {
      fontSize: theme.typography.body1.fontSize,
      fontWeight: 600,
      textDecoration: 'underline',
    },
    addInfoButton: {
      height: theme.spacing(7),
      width: '100%',
      borderRadius: theme.spacing(4),
      marginBottom: theme.spacing(1),
      [theme.breakpoints.down('xs')]: {
        marginBottom: 0,
      },
    },
    card: {
      width: '60%',
      margin: theme.spacing(3),
      marginTop: theme.spacing(5),
      marginBottom: 0,
      padding: theme.spacing(3, 0),
      borderColor: '#E5E7EB',
      [theme.breakpoints.down('xs')]: {
        width: '90%',
        padding: theme.spacing(2, 0),
        marginTop: theme.spacing(3),
      },
    },
    infoLabel: {
      fontSize: theme.typography.body1.fontSize,
      color: '#4B5563',
      paddingTop: theme.spacing(1),
    },
    secondaryText: {
      display: 'flex',
      color: theme.palette.secondary.main,
    },
    infoText: {
      color: theme.palette.text.primary,
      paddingTop: theme.spacing(1),
      fontSize: theme.spacing(2),
      width: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    unsetColor: {
      color: '#D1D5DB',
    },
    dividerStyle: {
      backgroundColor: '#E5E7EB',
    },
    socialBox: {
      borderBottom: '1px solid #EBEBEC',
    },
    socialLabel: {
      paddingLeft: theme.spacing(1),
      // color: '#9CA3AF',
      fontSize: theme.spacing(2),
    },
    dialogContent: {
      paddingBottom: theme.spacing(4),
    },
    logoutButton: {
      height: theme.spacing(7),
    },
  }),
)

const ProfileAccount = () => {
  const classes = useStyles()
  const history = useHistory()
  const authRedirect = useAuthRedirect()
  const dispatch = useDispatch()
  const { t, i18n } = useTranslation()
  const { userInfo } = useUserSession()
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down('xs'))
  const spacing = matches ? 2 : 3
  const handleClickShowPassword = () => setShowPassword((show) => !show)
  const [showPassword, setShowPassword] = useState(false)
  const order = useRouteMatch(`/${i18n.language}/profile/order`)
  const account = useRouteMatch(`/${i18n.language}/profile/account`)

  const DIALING_Label = {
    profile: t('profile.add_profile'),
    phone: t('profile.edit') + t('profile.tel_number'),
    email: t('profile.edit') + t('form.address_email'),
    WhatsApp: t('profile.edit') + 'WhatsApp',
    WeChat: t('profile.edit') + 'WeChat',
    changePassword: t('profile.change_pwd'),
  }

  const [openDrawer, setOpenDrawer] = useState({
    profile: false,
    WeChat: false,
    WhatsApp: false,
    changePassword: false,
    phone: false,
    email: false,
  })
  const [openDialog, setOpenDialog] = useState(false)
  const [activeDialogKey, setActiveDialogKey] = useState('profile')
  // const [WeChatId, setWeChatId] = useState(userInfo?.WeChatId || '')
  // const [WhatsAppId, setWhatsAppId] = useState(userInfo?.WhatsAppId || '')
  const initialValues = {
    dialingCode: userInfo?.dialingCode || '086',
    phone: userInfo?.phone || '',
    email: userInfo?.email || '',
    code: '',
  }

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }

    if (matches) {
      setOpenDrawer({ ...openDrawer, [anchor]: open })
    } else {
      setOpenDialog(true)
      setActiveDialogKey(anchor)
    }
  }

  const handleSignOut = () => {
    dispatch(signOut())
    toast.error(t('common.had_sign_out'))
    history.push(`/${i18n.language}`)
  }
  useEffect(() => {
    if (!userInfo) authRedirect()
  }, [])

  // const handleSignIn = () => authRedirect()
  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const formatGender = (val) => {
    return val === '0' ? t('form.male') : t('form.female')
  }
  const handleClose = (item, index) => {
    setAnchorEl(null)
    if (item) {
      history.push(`/${i18n.language}/${item.path}`)
    }
  }

  const handleReceiveInform = (event) => {
    dispatch(updateUserInfo({ id: userInfo.id, userStatus: event.target.checked ? '1' : '0' })).unwrap()
  }

  return (
    <>
      {/* header */}

      <Box className={classes.header}>
        <Box>
          {matches && (
            <Box mb={1} mx={3} display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="h3" className={classes.title}>
                {t('common.my_account')}
              </Typography>
              <Button
                id="basic-button"
                // variant="outlined"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClickMenu}
                endIcon={<ArrowDropDownIcon />}
                className={classes.menuButton}
              >
                {order && (
                  <>
                    {' '}
                    <Appointment className={classes.menuButtonIcon} />
                    {t('profile.my_appointment')}
                  </>
                )}
                {account && (
                  <>
                    <PersonOutlineOutlinedIcon className={classes.menuButtonIcon} />
                    {t('glossary.personal_info')}
                  </>
                )}
              </Button>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={() => {
                  handleClose()
                }}
                getContentAnchorEl={null}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
              >
                {MENU_LIST.map((item, index) => (
                  <MenuItem
                    key={item.label}
                    onClick={() => {
                      buttonClick(item.buttonName, item.buttonName)
                      handleClose(item, index)
                    }}
                    className={classes.menuItem}
                  >
                    <item.icon className={classes.menuItemIcon} />
                    {t(item.label)}
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          )}
          {matches && <Divider className={classes.dividerStyle} />}{' '}
        </Box>
      </Box>

      <Switch onClick={(e)=>{console.log(e, 'e')}}>
        <Route exact path={`/${i18n.language}/profile/account`}>
          <Box display="flex" flexDirection="column" alignItems={matches && 'center'}>
            {/* main */}
            <Card variant="outlined" className={classes.card}>
              <Box mx={spacing} mb={spacing}>
                <Typography variant="h4" color="secondary" className={classes.title}>
                  {t('profile.account_login')}
                </Typography>
              </Box>
              <Divider className={classes.dividerStyle} />
              <Box mx={spacing}>
                {ACCOUNTS.map((item) => (
                  <Box key={item.key} mb={1}>
                    <Box my={matches ? 1 : 2} display="flex" justifyContent="space-between">
                      <Box className={classes.infoLabel} width="80%">
                        {t(item.label)}
                        <Typography variant="h4" className={classes.infoText}>
                          {item.key === 'phone' && userInfo?.dialingCode ? `+${userInfo?.dialingCode} ` : ''}
                          {userInfo && userInfo[item.key] ? (
                            userInfo && userInfo[item.key]
                          ) : (
                            <Box color="#D1D5DB">{t('profile.unset')}</Box>
                          )}
                        </Typography>
                      </Box>
                      <Button
                        className={classes.editAccountButton}
                        variant="text"
                        onClick={toggleDrawer(item.key, true)}
                      >
                        {userInfo && userInfo[item.key] ? t('profile.edit') : t('profile.add')}
                      </Button>
                    </Box>
                    <Divider className={classes.dividerStyle} />
                  </Box>
                ))}
                <Button
                  className={classes.accountButton}
                  fullWidth
                  variant="outlined"
                  onClick={toggleDrawer('changePassword', true)}
                >
                  {t('profile.change_pwd')}
                </Button>
              </Box>
            </Card>
            <Card variant="outlined" className={classes.card}>
              <Box mx={spacing} mb={spacing}>
                <Typography variant="h4" color="secondary" className={classes.title}>
                  {t('glossary.personal_info')}
                </Typography>
                {userInfo?.nameCn && (
                  <Typography variant="body1" className={classes.infoLabel}>
                    {t('profile.call_change_profile')}
                  </Typography>
                )}
              </Box>
              <Divider className={classes.dividerStyle} />
              {userInfo?.nameEn ? (
                PROFILE_LIST.map((item, index) => (
                  <Box
                    key={item.label}
                    // className={index === 0 ? classes.socialBox : ''}
                    mx={spacing}
                    mt={1}
                  >
                    <Box className={classes.infoLabel} mb={2} position="relative">
                      {t(item.label)}
                      <Typography variant="h4" className={classes.infoText}>
                        {userInfo && item.key === 'gender'
                          ? formatGender(userInfo[item.key])
                          : userInfo && item.key === 'identifyId'
                          ? showPassword
                            ? userInfo?.identifyId
                            : encryptId(userInfo?.identifyId, userInfo?.identifyType)
                          : userInfo && userInfo[item.key]}
                      </Typography>

                      {userInfo && item.key === 'identifyId' && (
                        <Box position="absolute" right={20} top={45}>
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              edge="end"
                            >
                              {!showPassword ? (
                                <VisibilityOffOutlined color="primary" />
                              ) : (
                                <VisibilityOutlined color="primary" />
                              )}
                            </IconButton>
                          </InputAdornment>
                        </Box>
                      )}
                    </Box>
                    {index < PROFILE_LIST.length - 1 && <Divider className={classes.dividerStyle} />}
                  </Box>
                ))
              ) : (
                <Box mx={spacing} mt={1}>
                  <Button
                    fullWidth
                    color="secondary"
                    variant="contained"
                    className={[classes.accountButton, matches ? {} : classes.addInfoButton]}
                    onClick={toggleDrawer('profile', true)}
                    startIcon={<AddIcon />}
                  >
                    {t('profile.add_profile')}
                  </Button>
                  <Typography variant="body1" className={[classes.infoLabel, classes.secondaryText]}>
                    <Exclamation />
                    {t('profile.add_profile_tip')}
                  </Typography>
                </Box>
              )}
            </Card>
            <Card variant="outlined" className={classes.card}>
              {SOCIAL_ACCOUNT.map((item, index) => (
                <Box
                  key={item.label + index}
                  className={index === 0 ? classes.socialBox : ''}
                  px={spacing}
                  pt={index === 1 ? 2 : 0}
                  pb={index === 0 ? 2 : 0}
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Box display="flex" alignItems="center">
                    <item.icon />
                    <Typography variant="h4" className={classes.socialLabel}>
                      {(userInfo && userInfo[item.key]) || item.label}
                    </Typography>
                  </Box>
                  <Button
                    className={classes.editAccountButton}
                    variant="text"
                    onClick={toggleDrawer(item.label, true)}
                  >
                    {userInfo && userInfo[item.key] ? t('profile.edit') : t('profile.add')}
                  </Button>
                </Box>
              ))}
            </Card>
            <Card variant="outlined" className={classes.card}>
              <Box mx={spacing} mb={spacing}>
                <Typography variant="h4" color="secondary" className={classes.title}>
                  {t('profile.inform_set')}
                </Typography>
              </Box>
              <Divider className={classes.dividerStyle} />
              <Box mt={spacing} mx={matches ? 1 : 2} display="flex" justifyContent="space-between">
                <Box ml={1}>
                  <Typography variant="h4" className={classes.title}>
                    {t('profile.receive_inform')}
                  </Typography>
                  <Typography variant="body1" className={classes.infoLabel}>
                    {t('profile.receive_inform_tip')}
                  </Typography>
                </Box>
                <ESwitch
                  checked={userInfo?.userStatus === '1' ? true : false}
                  onChange={handleReceiveInform}
                />
              </Box>
            </Card>
            <Box mx={3} my={matches ? 3 : 5} width={matches ? '90%' : '183px'}>
              {/* {authenticated && ( */}
              <EDialog
                title={t('are_you_sure.sign_out')}
                trigger={
                  <Button disableElevation fullWidth className={classes.logoutButton} variant="outlined">
                    {t('common.sign_out')}
                  </Button>
                }
                onConfirm={handleSignOut}
              />
              {/* )} */}
            </Box>
          </Box>
        </Route>
        <Route path={`/${i18n.language}/profile/order`}>
          <OrderList />
        </Route>
      </Switch>
      {/* {!activeMenuIndex ? (
      
      ) : (
      )} */}

      {/* drawer for mobile */}
      <EDrawer
        onClose={toggleDrawer('profile', false)}
        open={openDrawer.profile}
        title={DIALING_Label['profile']}
      >
        <UserInfoForm userInfo={userInfo} onConfirm={toggleDrawer('profile', false)} />
      </EDrawer>
      <EDrawer
        onClose={toggleDrawer('changePassword', false)}
        open={openDrawer.changePassword}
        title={DIALING_Label['changePassword']}
      >
        <ChangePasswordForm userInfo={userInfo} onConfirm={toggleDrawer('changePassword', false)} />
      </EDrawer>
      <EDrawer onClose={toggleDrawer('phone', false)} open={openDrawer.phone} title={DIALING_Label['phone']}>
        <ChangePhoneForm
          field="phone"
          initialValue={initialValues.phone}
          dialingCode={userInfo?.dialingCode}
          phone={userInfo?.phone}
          onConfirm={toggleDrawer('phone', false)}
        />
      </EDrawer>
      <EDrawer onClose={toggleDrawer('email', false)} open={openDrawer.email} title={DIALING_Label['email']}>
        <ChangePhoneForm
          field="email"
          initialValue={initialValues.email}
          email={userInfo?.email}
          onConfirm={toggleDrawer('email', false)}
        />
      </EDrawer>
      <EDrawer
        onClose={toggleDrawer('WeChat', false)}
        open={openDrawer.WeChat}
        title={DIALING_Label['WeChat']}
      >
        <ChangeSocialAccountForm
          userInfo={userInfo}
          field="weChatId"
          onConfirm={toggleDrawer('WeChat', false)}
        />
      </EDrawer>
      <EDrawer
        onClose={toggleDrawer('WhatsApp', false)}
        open={openDrawer.WhatsApp}
        title={DIALING_Label['WhatsApp']}
      >
        <ChangeSocialAccountForm
          userInfo={userInfo}
          field="whatsAppId"
          onConfirm={toggleDrawer('WhatsApp', false)}
        />
      </EDrawer>

      {/* dialog for pc */}
      <Dialog
        maxWidth="xs"
        open={openDialog}
        fullWidth
        onClose={() => {
          setOpenDialog(false)
        }}
      >
        <Box mb={2}>
          <Box py={2} fontSize={20} fontWeight={600} textAlign="center">
            {DIALING_Label[activeDialogKey]}
          </Box>
          <IconButton
            className={classes.closeButton}
            aria-label="close"
            onClick={() => {
              setOpenDialog(false)
            }}
            color="primary"
          >
            <CloseIcon />
          </IconButton>
          <Divider className={classes.dividerStyle} />
        </Box>
        <DialogContent className={classes.dialogContent}>
          {activeDialogKey === 'profile' && (
            <UserInfoForm
              userInfo={userInfo}
              onConfirm={() => {
                setOpenDialog(false)
              }}
            />
          )}
          {activeDialogKey === 'phone' && (
            <ChangePhoneForm
              field="phone"
              initialValue={initialValues.phone}
              dialingCode={userInfo?.dialingCode}
              phone={userInfo?.phone}
              onConfirm={() => {
                setOpenDialog(false)
              }}
            />
          )}
          {activeDialogKey === 'email' && (
            <ChangePhoneForm
              field="email"
              initialValue={initialValues.email}
              email={userInfo?.email}
              onConfirm={() => {
                setOpenDialog(false)
              }}
            />
          )}
          {activeDialogKey === 'WhatsApp' && (
            <ChangeSocialAccountForm
              userInfo={userInfo}
              field="whatsAppId"
              onConfirm={() => {
                setOpenDialog(false)
              }}
            />
          )}
          {activeDialogKey === 'WeChat' && (
            <ChangeSocialAccountForm
              userInfo={userInfo}
              field="weChatId"
              onConfirm={() => {
                setOpenDialog(false)
              }}
            />
          )}
          {activeDialogKey === 'changePassword' && (
            <ChangePasswordForm
              userInfo={userInfo}
              onConfirm={() => {
                setOpenDialog(false)
              }}
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  )
}

export default ProfileAccount
